'use client';

import { IntlFileKind } from '@/lib/recruitment/intl-application';
import { FileUploadCard } from '@/components/recruitment/intl/FileUploadCard';
import { StepNav } from '@/components/recruitment/intl/steps/StepNav';

export function DocumentsStep({
  token,
  labels,
  files,
  onUploaded,
  onExpired,
  onBack,
  onContinue,
}: {
  token: string;
  /** Upload labels and hints as worded in Recruitment -> Job Applications. */
  labels?: Record<string, { label: string; hint: string }>;
  files: Partial<Record<IntlFileKind, string | null>>;
  onUploaded: (kind: IntlFileKind, fileName: string, completedSteps: string[]) => void;
  onExpired: () => void;
  onBack: (() => void) | null;
  onContinue: () => void;
}) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-400">
        {labels?.resume?.hint || 'Upload your most recent resume or CV as a PDF or Word document.'}
      </p>
      <FileUploadCard
        token={token}
        kind="resume"
        label={labels?.resume?.label}
        fileName={files.resume ?? null}
        onUploaded={onUploaded}
        onExpired={onExpired}
      />
      <StepNav
        onBack={onBack}
        onContinue={onContinue}
        continueDisabled={!files.resume}
        disabledHint="Upload your resume to continue."
      />
    </div>
  );
}
